export default __webpack_public_path__ + "static/media/AmbassadorOpen1.e5e5e98a.jpg";